export class CallbackPreventDefault extends Error {
  constructor(message) {
    super(message)
    this.name = 'CallbackPreventDefault'
  }
}
